<template>
  <div class="bsdwz">
    <p class="bt1">1、需要解决的视觉问题有:</p>
    <div class="sjwt">
      <p>
        <el-checkbox v-model="checkList[0]" label="看远模糊"></el-checkbox>
        <span>度数变化;眼健康问题</span>
      </p>
      <p>
        <el-checkbox v-model="checkList[1]" label="近看模糊"></el-checkbox>
        <span>双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox v-model="checkList[2]" label="视物变形"></el-checkbox>
        <span>散光度数变化;镜片老化变形</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox v-model="checkList[0]" label="视物重影"></el-checkbox>
        <span>散光原因;双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox v-model="checkList[1]" label="眼睛干涩"></el-checkbox>
        <span>千眼问题</span>
      </p>
      <p>
        <el-checkbox v-model="checkList[2]" label="胀疼疲劳"></el-checkbox>
        <span>度数未正确矫正;双眼视功能异常;眼压高</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox v-model="checkList[0]" label="怕光"></el-checkbox>
        <span>屈光不正；弱视；角膜健康问题</span>
      </p>
      <p>
        <el-checkbox v-model="checkList[1]" label="验光配镜"></el-checkbox>
      </p>
      <p>
        <el-checkbox v-model="checkList[2]" label="复查管理"></el-checkbox>
      </p>
    </div>
    <div class="qitsq">
      <p>本次其他主诉需求:</p>
      <input type="text">
    </div>


    <p class="bt1" style="margin-top: 30px;">2、视力/视觉相关:</p>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.看不清楚有多长时间？</p>
        <p>了解视力下降有多长时间</p>
      </div>
      <div><input type="text">月</div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.最近一次检查视力在什么时间?</p>
        <p>了解最近有没有检查过视力，同时看结果有没有参考意义</p>
      </div>
      <div>
        <input type="text">年
        <input type="text">月
        <el-checkbox v-model="checkList[0]" label="没有检查过视力"></el-checkbox>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否做过眼轴、角膜曲率、视功能等视觉发育的全面检查?</p>
        <p>是否了解过眼睛生物学参数,知晓视力出现问题的原因</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否在宝视达建有视力档案?</p>
        <p>了解有没有建立眼健康档案的意识;是否有历史检查数据做对比</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否定期进行眼轴检查?</p>
        <p>是否了解定期检查眼轴的意义;是否有历史检查数据做对比</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否做过视力的相关治疗、保健和视功能训练?</p>
        <p>了解对视力的重视程度;了解对视觉问题的处理是否有正确的认知</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否使用低浓度的阿托品?</p>
        <p>如果有使用，要关注使用前后眼轴的变化情况</p>
        <p>如果有使用，要关注到对眼睛调节功能的影响</p>
        <p>评估现有的近视防控手段，为接下来的方案做参考</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有体育、球类运动距离感差?</p>
        <p>了解视认知和双眼视功能的异常是否影响到运动视觉</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>

    <p class="bt1" style="margin-top: 30px;">3、旧镜史相关:</p>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 80%;">
        <p>.既往矫正方式:</p>
        <p>根据既往配戴史看配戴效果,为接下来的方案提供参考</p>

        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="复单光眼镜"></el-checkbox>
            <el-checkbox label="框架离焦眼镜"></el-checkbox>
            <el-checkbox label="软性离焦眼镜"></el-checkbox>
            <el-checkbox label="RGP"></el-checkbox>
            <el-checkbox label="OK镜"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>
          <input style="padding-left: 10px;" type="text">
        </div>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <div style="display: flex;">
          <p>.现在配戴的镜片类型:</p>
          <input style="width: 100px;padding-left: 10px;" type="text">
        </div>
        <p>了解视力下降有多长时间</p>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴清晰度:</p>
      </div>
      <div>
        <el-radio v-model="radio" label="1">不清</el-radio>
        <el-radio v-model="radio" label="2">良好</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴舒适度:</p>
      </div>
      <div>
        <el-radio v-model="radio" label="1">不适</el-radio>
        <el-radio v-model="radio" label="2">良好</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.眼镜是否一直配戴:</p>
      </div>
      <div>
        <el-radio v-model="radio" label="1">是全天候配戴</el-radio>
        <el-radio v-model="radio" label="2">需要使用的时候戴，其他时间不戴</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次换镜适应情况:</p>
        <p>了解眼睛适应能力,为本次处方选择提供参考</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">无需适应</el-radio>
        <el-radio v-model="radio" label="2">需要适应</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.现在的 眼镜情况:</p>
        <p>了解对旧镜矫正视力的影响程度</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">变形</el-radio>
        <el-radio v-model="radio" label="2">磨损</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.一般多久更换一次眼镜:</p>
        <p>看是否及时更换眼镜;评估度数变化速度</p>
      </div>
      <div><input type="text">月</div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次更换时一般变化多少度:</p>
        <p>看是否及时更换眼镜;评估度数变化速度</p>
      </div>
      <div><input type="text">度</div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.运动时配戴框架眼镜是否方便:</p>
        <p>本次处方方案要考虑配戴方式的影响,如果有,优先考虑接触镜方案</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>


    <p class="bt1" style="margin-top: 30px;">4、用眼和饮食习惯相关:</p>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天看书写作业等近距离用眼有多长时间?</p>
        <p>了解近距离用眼量,评估双眼视功能和用眼需求是否匹配</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">2小时以内</el-radio>
        <el-radio v-model="radio" label="2">2~4小时</el-radio>
        <el-radio v-model="radio" label="2">4小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天户外活动多长时间?</p>
        <p>了解户外活动时长是否充足,时间不足的要考虑用全光谱护眼灯补足</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">很少</el-radio>
        <el-radio v-model="radio" label="2">2小时以内</el-radio>
        <el-radio v-model="radio" label="2">2小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天睡眠多长时间?</p>
        <p>了解休息是否充足,是否影响度数稳定</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">6小时以内</el-radio>
        <el-radio v-model="radio" label="2">6~8小时</el-radio>
        <el-radio v-model="radio" label="2">8小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天睡眠多长时间?</p>
        <p>了解休息是否充足,是否影响度数稳定</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">很少</el-radio>
        <el-radio v-model="radio" label="2">2小时以内</el-radio>
        <el-radio v-model="radio" label="2">2~4小时</el-radio>
        <el-radio v-model="radio" label="2">4小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.阅读、写作业等近距离用眼是否有以下问题？</p>
        <p>了解是否有双眼视功能异常的相关症状,好针对性的检查和处理</p>

        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="速度慢"></el-checkbox>
            <el-checkbox label="丢字"></el-checkbox>
            <el-checkbox label="漏字"></el-checkbox>
            <el-checkbox label="重影串行"></el-checkbox>
            <el-checkbox label="注意力不集中"></el-checkbox>
            <el-checkbox label="犯困"></el-checkbox>
            <el-checkbox label="头疼"></el-checkbox>
            <el-checkbox label="易疲劳"></el-checkbox>
            <el-checkbox label="聚焦困难"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.视线远近交替是否有模糊,反应速度慢</p>
        <p>了解是否有调节灵敏度的异常,好针对性的检查和处理</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.是否有以下用眼习惯？</p>
        <p>了解是否有不良用眼习惯,用于评估用眼习惯和视力之间的相关影响</p>

        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="眯眼"></el-checkbox>
            <el-checkbox label="歪头"></el-checkbox>
            <el-checkbox label="趴的近"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否挑食？</p>
      </div>
      <div>
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否喜欢吃甜食？</p>
        <p>是否饮食问题导致近视或涨度数</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>



    <p class="bt1" style="margin-top: 30px;">5、健康状况:</p>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有过敏史？</p>
        <p>了解对哪些过敏,给最终处方时要规避此影响</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有眼病史？</p>
        <p>了解眼病史,矫正视力不良时,能全面考虑</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.家人是否有以下眼部问题</p>
        <p>了解是否有家族遗传史</p>

        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="近视"></el-checkbox>
            <el-checkbox label="斜视"></el-checkbox>
            <el-checkbox label="弱视"></el-checkbox>
            <el-checkbox label="色觉异常"></el-checkbox>
            <el-checkbox label="无"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>


    <p class="bt1" style="margin-top: 30px;">5、出生史相关:</p>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生时是否早产：</p>
        <p>跟弱视相关:早产更容易出现弱视</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生体重：</p>
        <p>体重小更容易出现弱视,体重大容易形成近视</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1"><5斤</el-radio>
        <el-radio v-model="radio" label="2">5~8斤</el-radio>
        <el-radio v-model="radio" label="2">≥8斤</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生是否照过蓝光(黄疸值高)：</p>
        <p>照蓝光可能会损伤眼底</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有吸氧史?</p>
        <p>会引发视网膜病变,永久性损伤视力</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="2">否</el-radio>
        <span>吸氧浓度和持续时长</span>
        <input style="padding-left: 10px;" type="text">
      </div>
    </div>


    <div style="padding-top: 20px;">  <el-button type="primary">保存</el-button></div>

  </div>
</template>




<script>
export default {
  name:"bsdwz",
  data(){
    return {
      checkList: [false,false,false,false,false,false,false,false,false,]
    }
  }
}

</script>






<style scoped lang="scss">
.bsdwz {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 20px;
}
.bt1 {
  text-align: left;
  padding: 5px 10px;
  background: #e5e5e5;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 20px;
}

.sjwt {
  display: flex;
  text-align: left;
  padding-bottom: 15px;
  p {
    width: 33%;
    span {
      display: block;
      font-size: 13px;
      color: #8eb2ff;
      padding-left: 25px;
    }
  }
}

.qitsq {
  display: flex;
  align-content: center;
  input {
    width: calc(100% - 150px);
    margin-left: 20px;
    border: none;
    border-bottom: 1px solid #000000;
  }
}

.slxgbox {
  display: flex;
  align-content: center;
  text-align: left;
  border-bottom: 1px dashed #818181;
  padding-bottom: 5px;
  margin-bottom: 10px;
  .slxgbox-a {
    width: 60%;
    p{color: #8eb2ff;font-size: 14px;}
    p:nth-child(1) {color: #000000;}
  }
  input {
    width: 50px;
    border: none;
    border-bottom: 1px solid #000000;
  }
}

</style>